import {
    GET_CURRENT_PAGES
} from './constants';

const initialState = {
    currentPages: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_PAGES: {
            return {
                ...state,
                currentPages: action.payload,
            };
        }
        default:
            return state;
    }
};

